import { Platform } from "react-native";
import { theme } from "../../../theme/theme";
const getFontVariant = ({ variant, currentTheme }) => {
    const { fontHeading, fontAction, fontDetail, fontDetailBold, fontHeadingDisplay, fontBody } = currentTheme;
    const variantMap = {
        body: fontBody,
        heading: fontHeading,
        action: fontAction,
        detail: fontDetail,
        detailBold: fontDetailBold,
        headingDisplay: fontHeadingDisplay,
    };
    return variantMap[variant];
};
const buildFontStyle = ({ fontVariant, level, currentTheme }) => {
    const getThemeValue = (key) => currentTheme[key];
    const fontMap = getThemeValue("fontMap") || {};
    const customFont = fontMap[fontVariant];
    const fontFamily = customFont || fontVariant;
    // A mapped custom font file already carries its own weight and style, so
    // emitting fontWeight/fontStyle alongside it is redundant. On iOS it is also
    // harmful: React Native 0.83 collapses a non-zero fontWeight to 1.0 when the
    // family resolves to a font name rather than a family name, which renders
    // every weighted text at maximum boldness. Fixed upstream in 0.86.3, but the
    // host app (user-area-front) still runs these packages on RN 0.83, so keep
    // the guard until every host reaches 0.86.3.
    const fontStyle = {
        fontFamily,
        fontSize: getThemeValue(`font${fontVariant}Size${level}`),
        lineHeight: getThemeValue(`font${fontVariant}Height${level}`),
        letterSpacing: getThemeValue(`font${fontVariant}LetterSpacing${level}`),
        ...(customFont
            ? {}
            : {
                fontWeight: getThemeValue(`font${fontVariant}Weight${level}`),
                fontStyle: getThemeValue(`font${fontVariant}Style${level}`),
            }),
    };
    return Object.fromEntries(Object.entries(fontStyle).filter(([, value]) => value !== undefined));
};
const style = ({ level, variant }) => {
    const currentTheme = theme();
    const fontVariant = getFontVariant({ variant, currentTheme });
    const fontStyle = buildFontStyle({ fontVariant, level, currentTheme });
    return {
        ...fontStyle,
        color: currentTheme.colorText,
        ...Platform.select({
            web: {
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale",
                textRendering: "optimizeLegibility",
            },
        }),
    };
};
export { style };
